package data.datasource.local

/**
 * Browser localStorage implementation for Kotlin/JS
 */
private class BrowserLocalStorage : LocalStorage {
    
    override fun getString(key: String): String? {
        return try {
            js("localStorage.getItem(key)") as String?
        } catch (e: Throwable) {
            null
        }
    }
    
    override fun setString(key: String, value: String) {
        try {
            js("localStorage.setItem(key, value)")
        } catch (e: Throwable) {
            // Handle storage quota exceeded or other errors
            println("Failed to set localStorage item: ${e.message}")
        }
    }
    
    override fun remove(key: String) {
        try {
            js("localStorage.removeItem(key)")
        } catch (e: Throwable) {
            println("Failed to remove localStorage item: ${e.message}")
        }
    }
    
    override fun clear() {
        try {
            js("localStorage.clear()")
        } catch (e: Throwable) {
            println("Failed to clear localStorage: ${e.message}")
        }
    }
}

/**
 * Actual implementation for JS platform
 */
actual fun createLocalStorage(): LocalStorage = BrowserLocalStorage()
